import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-jquidroppable',
	templateUrl:'./JQUIDroppablePage.html',
	styles: [],
	styleUrls:['./JQUIDroppablePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class JQUIDroppablePage
{
	mdContent_201 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.droppable.JQUIDroppable;
\`\`\``;
	mdContent_202 = `\`\`\`java
new JQUIDroppable&lt;&gt;()
\`\`\``;
	mdContent_203 = `\`\`\`java
var target = new JQUIDroppable<>();
target.setText("Drop here");
target.getOptions().setAccept(".draggable");
\`\`\``;
}
